// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XPCj","importantInfo":"styles_importantInfo__32oev"};